const HealthAndFamilydata = [
    {
        id : "1",
        schemeName: "Aayushman Bharat.",
        discription:" Ayushman Bharat is National Health Protection Scheme, which will cover over 10 crore poor                                                                                                                                                                                                                                                            and   vulnerable families (approximately 50 crore beneficiaries) providing coverage upto 5 lakh rupees per family per year for secondary and tertiary care hospitalization. Ayushman Bharat - National Health Protection Mission will subsume the on-going centrally sponsored schemes .",
        launchDate: "23 September 2018",
        AnualFund: "12345"

    },
   {id : "2",
    schemeName: "Janani Suraksha Yojna.",
    discription:"Janani Suraksha Yojana (JSY) is a safe motherhood intervention under the National Rural Health Mission (NHM). The scheme is under implementation in all states and Union Territories (UTs), with a special focus on Low Performing States (LPS). Janani Suraksha Yojana was launched in April 2005 by modifyin",
    launchDate: "April 2005",
    AnualFund: "12345"},
   

    {id : "3",
    schemeName: "Janani Shishu Suraksha KaryaKaram",
    discription:"Janani-Shishu Suraksha Karyakram supplements the cash assistance given to a pregnant woman under Janani Suraksha Yojana and is aimed at mitigating the burden of out of pocket expenses incurred by pregnant women and sick newborns.",
    launchDate: "1 June 2011",
    AnualFund: "12345"},
   
    {
    id : "4",
        schemeName: "Rashtriya Kishor Swasthya KaryaKaram",
        discription:"The Rashtriya Kishor Swasthya Karyakram (National Adolescent Health Programme), will comprehensively address the health needs of the 243 million adolescents.",
        launchDate: "7 January 2014",
        AnualFund: "12345"
    },
   { id : "5",
    schemeName: "Mission Indradhanush (MI)",
    discription:"Mission Indradhanush is a health mission of the Government of India. It was launched by Union Health Minister J. P. Nadda on 25 December 2014.",
    launchDate: "25 December 2014", 
     AnualFund: "12345"},
   

]

export default HealthAndFamilydata;